import { Directive, HostListener, Input } from '@angular/core';
import { NavController } from '../../providers/nav-controller';
var RouterDirection = /** @class */ (function () {
    function RouterDirection(navCtrl) {
        this.navCtrl = navCtrl;
    }
    RouterDirection.prototype.onClick = function () {
        this.navCtrl.setIntent(textToIntent(this.routerDirection));
    };
    RouterDirection.decorators = [
        { type: Directive, args: [{
                    selector: '[routerDirection]',
                },] },
    ];
    /** @nocollapse */
    RouterDirection.ctorParameters = function () { return [
        { type: NavController }
    ]; };
    RouterDirection.propDecorators = {
        routerDirection: [{ type: Input }],
        onClick: [{ type: HostListener, args: ['click',] }]
    };
    return RouterDirection;
}());
export { RouterDirection };
function textToIntent(direction) {
    switch (direction) {
        case 'forward': return 1 /* Forward */;
        case 'back': return 2 /* Back */;
        case 'root': return 3 /* Root */;
        default: return 0 /* Auto */;
    }
}
